import classNames from "clsx";
import { ReactNode } from "react";

const frameBorderClass = [
  "flex",
  "flex-col",
  "grow",
  "border",
  "border-background-surface-neutral-subtle",
  "rounded-lg",
  "overflow-hidden",
];

const sectionHeaderClass = [
  "px-4",
  "py-3",
  "flex",
  "items-center",
  "border-b",
  "border-background-surface-neutral-subtle",
  "rounded-t-lg",
  "bg-background-surface",
  "justify-between",
];

const titleClass = ["font-semibold", "text-base", "leading-6"];

type FormProps = {
  title?: string;
  headerItem?: ReactNode;
  children: ReactNode;
  footerItem?: ReactNode;
};

type PreviewProps = {
  title?: string;
  headerItem?: ReactNode;
  children: ReactNode;
};

const EditorFormContainer = ({ title, headerItem, children, footerItem }: FormProps) => {
  return (
    <div
      className={classNames("max-w-[500px]", "min-w-[500px]", frameBorderClass)}
      data-testid="container-form-wrapper"
    >
      <div className={classNames(sectionHeaderClass)} data-testid="container-form-header">
        <span className={classNames(titleClass)}>{title}</span>
        {headerItem}
      </div>
      <div className={classNames("overflow-auto", "h-full")} data-testid="container-form-body">
        {children}
      </div>
      {!!footerItem && (
        <footer
          className={classNames(
            "flex",
            "justify-end",
            "border-t",
            "border-background-surface-neutral-subtle",
            "bg-background-surface",
            "p-2"
          )}
        >
          {footerItem}
        </footer>
      )}
    </div>
  );
};

const EditorPreviewContainer = ({ title, headerItem, children }: PreviewProps) => {
  return (
    <div className={classNames("w-fit", frameBorderClass)} data-testid="container-preview-wrapper">
      <div className={classNames(sectionHeaderClass)} data-testid="container-preview-header">
        <span className={classNames(titleClass)}>{title}</span>
        {headerItem}
      </div>
      <div className="grow overflow-auto" data-testid="container-preview-body">
        {children}
      </div>
    </div>
  );
};

const EditorContainer = ({ children }: { children: ReactNode[] }) => {
  return (
    <div
      className={classNames("flex", "p-6", "w-full", "h-full", "gap-x-6", "bg-background-surface-neutral")}
      data-testid="editor-container"
    >
      {children}
    </div>
  );
};

EditorContainer.Form = EditorFormContainer;
EditorContainer.Preview = EditorPreviewContainer;

export default EditorContainer;
